/**
 * @param {string} eventName
 * @param {string} query
 * @param {Element} delegate
 * @param {Function} cb
 */
export default (eventName, query, delegate, cb) => {
  delegate.addEventListener(eventName, function delegateListener(...params) {
    for (let { target } = params[0]; target && target !== this; target = target.parentNode) {
      if (target.matches(query)) {
        cb({ ...params, target });
        break;
      }
    }
  });
};
